import { editEventError } from "@planzone/dto";
import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    getEditEventError({ uuid }) {
      const req = getState().find(({ event }) => event.uuid === uuid);

      return req ? req.error : editEventError;
    },
    isEditEventRequestFailure({ uuid }) {
      const req = getState().find(({ event }) => event.uuid === uuid);

      return req ? req.request.isFailure : false;
    },
    isEditEventRequestPending({ uuid }) {
      const req = getState().find(({ event }) => event.uuid === uuid);

      return req ? req.request.isPending : false;
    },
    isEditEventRequestSuccess({ uuid }) {
      const req = getState().find(({ event }) => event.uuid === uuid);

      return req ? req.request.isSuccessful : false;
    },
  };
}

export { createSelector };
